module.exports = __webpack_public_path__ + "img/2_2.e2c48237.jpg";